import Swiper from 'swiper'
import { Navigation, Pagination, Scrollbar } from 'swiper/modules'

import Block from '../block'

export default class SwiperCarousel extends Block {
	static title = 'block-gallery__inner-swiper'

	constructor($el) {
		super($el)

		this.setter()

		const carousel = new Swiper(this.$el.find('.swiper').get(0), {
			modules: [Navigation, Pagination, Scrollbar],
			speed: this.speed,
			spaceBetween: 16,
			slidesPerView: 'auto',
			navigation: {
				nextEl: this.$el.find('.swiper-nav-next').get(0),
				prevEl: this.$el.find('.swiper-nav-prev').get(0),
			},
		})

		carousel.on('slideNextTransitionStart', () => {
			const totalSlides = carousel.slides.length

			if (carousel.activeIndex == totalSlides - this.slideReset) {
				carousel.slideTo(0, 600, false)

				this.ChangeSiperContent()
			}
		})

		carousel.on('slideChangeTransitionEnd', () => {
			this.ChangeSiperContent()
		})
	}

	setter() {
		this.speed = 400
		this.slideReset = 2
	}

	ChangeSiperContent() {
		const activeSlide = this.$el.find('.swiper-slide-active')

		if (!activeSlide.length) {
			return
		}

		const title = activeSlide.attr('data-title') || ''
		const caption = activeSlide.attr('data-caption') || ''

		this.$el.find('.swiper-content-title').text(title)
		this.$el.find('.swiper-content-text').html(caption)

		// the template stamps hidden from the first image only, so a later slide carrying neither
		// would otherwise leave an empty caption panel behind
		this.$el
			.find('.swiper-content-inner')
			.toggleClass('hidden', !title && !caption)
	}
}
